import { BlurView, rem } from 'design-system';
import Text from 'design-system/Text';
import { useInterval } from 'hooks';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import React, { memo, useEffect, useState } from 'react';
import { Platform, View } from 'react-native';
import { Circle, Svg } from 'react-native-svg';
import createStyleSheets from 'utils/createStyleSheets';
import { splitCountdownTime } from '../utils';
const enableBlur = Platform.OS !== 'android';
export const CountdownTimer = ({ endDate, blurred, style, dark }) => {
    const [secondsTotalLeft, setSecondsTotalLeft] = useState(0);
    useEffect(() => {
        setSecondsTotalLeft((new Date(endDate).getTime() - Date.now()) / 1000);
    }, [endDate]);
    useInterval(() => setSecondsTotalLeft((seconds) => seconds - 1), secondsTotalLeft > 0 ? 1000 : undefined);
    const { hours, minutes, seconds } = splitCountdownTime(secondsTotalLeft);
    const styles = useStyles(styleSet);
    const colors = useColors();
    const separatorColor = blurred || dark ? colors.text.white : colors.text.secondary;
    return (<View style={[styles.container, style]}>
      <MemoizedCountdownSegment value={hours} blurred={blurred} dark={dark}/>
      <Separator color={separatorColor} smallSpacing={dark}/>
      <MemoizedCountdownSegment value={minutes} blurred={blurred} dark={dark}/>
      <Separator color={separatorColor} smallSpacing={dark}/>
      <CountdownSegment value={seconds} blurred={blurred} dark={dark}/>
    </View>);
};
const CountdownSegment = (props) => props.blurred ? (<BlurredCountdownSegment {...props}/>) : (<RegularCountdownSegment {...props}/>);
const RegularCountdownSegment = ({ value, dark }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const colorProp = dark ? { White: true } : { Secondary: true };
    const backgroundColor = dark
        ? colors.background.transparent
        : colors.cards.onLight;
    return (<View style={[styles.countdownSegment, { backgroundColor }]}>
      <Text Numbers-20 {...colorProp}>
        {value.toFixed().padStart(2, '0')}
      </Text>
    </View>);
};
const BlurredCountdownSegment = ({ value }) => {
    const styles = useStyles(styleSet);
    return (<View style={styles.countdownSegmentBlurred}>
      {enableBlur ? (<BlurView style={styles.blurred} blurType="light" reducedTransparencyFallbackColor="white" autoUpdate={false}/>) : (<View style={[styles.blurred, styles.blurredAndroid]}/>)}
      <Text Numbers-20 White>
        {value.toFixed().padStart(2, '0')}
      </Text>
    </View>);
};
const MemoizedCountdownSegment = memo(CountdownSegment);
const Separator = memo(({ color, smallSpacing }) => {
    const styles = useStyles(styleSet);
    return (<View style={[styles.separator, smallSpacing && styles.smallSpacing]}>
      <Svg width={rem(4)} height={rem(12)} viewBox="0 0 4 12" fill="none">
        <Circle cx="2" cy="2" r="1.5" fill={color}/>
        <Circle cx="2" cy="10" r="1.5" fill={color}/>
      </Svg>
    </View>);
});
const styleSet = createStyleSheets((colors) => ({
    container: { flexDirection: 'row', padding: rem(16) },
    countdownSegment: {
        minWidth: rem(44),
        height: rem(44),
        paddingHorizontal: rem(10),
        borderRadius: rem(8),
        alignItems: 'center',
        justifyContent: 'center',
    },
    countdownSegmentBlurred: {
        minWidth: rem(44),
        height: rem(44),
        paddingHorizontal: rem(10),
        alignItems: 'center',
        justifyContent: 'center',
        borderWidth: rem(1),
        borderRadius: rem(8),
        overflow: 'hidden',
        borderColor: colors.elements.white,
    },
    blurred: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        position: 'absolute',
    },
    blurredAndroid: {
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
    },
    separator: {
        paddingHorizontal: rem(16),
        justifyContent: 'center',
    },
    smallSpacing: {
        paddingHorizontal: rem(8),
    },
}));
